export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/pen_ink.b391918.png";